import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const tokenValue = this.authService.getToken();
    const tokenParam = route.queryParamMap.get('token');
    if (tokenValue && !tokenParam) {
      const redirectionUrl = route.queryParamMap.get('redirect_url');
      if (redirectionUrl) {
        this.router.navigateByUrl(redirectionUrl);
      } else {
        const homeUrl = this.authService.getPublicHomeUrl();
        if (typeof window !== 'undefined' && window?.location) {
          window.location.href = homeUrl;
        } else {
          this.router.navigateByUrl('/home');
        }
      }
      return false;
    } else {
      
      return true;
    }
  }
}
